import store from "./store";
const hospStore = {
    state: {
        lang: '',
        host: '', // 센터 구분
        hostNm: '',
        hostName: '',
    },
    mutations: {
        setLang: function (state, lang) {
            state.lang = lang;
        },
        setHost: function (state, host) {
            state.host = host;
        },
        setHostNm: function (state, hostNm) {
            state.hostNm = hostNm;
        },
        setHostName: function (state, hostName) {
            state.hostName = hostName;
        },
    },
    getters: {
        getLang: state => {
            return state.lang
        },
        getHost: state => {
            return state.host
        },
        getHostNm: state => {
            return state.hostNm
        },
        getHostName: state => {
            return state.hostName
        },
    },
    actions: {

    }
}

export default hospStore